

export const logo = require('../assets/images/LOGO.png')
export const logoVertical = require('../assets/images/LOGO_V.png')
export const placeholderImg = require('../assets/images/placeholder.png')